// extracted by css-extract-rspack-plugin
export default {"measuring":"GLgCG","header":"jY94o","row":"Hj5Nn","cell":"NDVrL"};